let baseUrl = "";
let baseUrlOrigin = "";
export const WebSocketURL = "wss://learning-business-showcase.digimasia.com/ws";

const environment = import.meta.env.VITE_ENVIRONMENT;

if (environment === "production") {
  baseUrl =
    "https://learning-business-showcase.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://learning-business-showcase.digimasia.com"
} else if (environment === "staging") {
  baseUrl =
    "https://lbs-staging.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://lbs-staging.digimasia.com"
} else {
  baseUrl =
    "https://lbs-staging.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://lbs-staging.digimasia.com"
}

export { baseUrlOrigin };
export default baseUrl;
